"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Components_1 = require("../../Components");
var Components_2 = require("../../../../Components");
var Types_1 = require("./Types");
var react_bootstrap_table2_toolkit_1 = require("react-bootstrap-table2-toolkit");
var react_bootstrap_table_next_1 = require("react-bootstrap-table-next");
var react_bootstrap_table2_paginator_1 = require("react-bootstrap-table2-paginator");
var moment = require("moment");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Services_1 = require("../../../../Services");
var Endpoints_1 = require("../../../../Utils/Endpoints");
var momentWrapper = function (moment) { return moment; };
var getReport = function (elem, id, resources, onExpand) {
    if (elem.isSinglePackResult) {
        var requestData = {};
        elem.packs && elem.packs.length && elem.packs.map(function (el) {
            requestData = {
                id: id,
                serialNumber: React.createElement("span", null, el.serialNumber),
                submissionTime: momentWrapper(moment)(elem.additionalInfo.submitTime && new Date(elem.additionalInfo.submitTime)).format("L LT"),
                action: elem.additionalInfo.action
            };
        });
        return requestData;
    }
    else {
        var requestData = {
            id: id,
            serialNumber: React.createElement("span", { style: { cursor: "pointer" }, onClick: function () { onExpand(); } },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "mr-2", icon: free_solid_svg_icons_1.faPlusCircle }),
                elem.additionalInfo.action,
                " (",
                elem.packs.length,
                ")"),
            submissionTime: momentWrapper(moment)(elem.additionalInfo.submitTime && new Date(elem.additionalInfo.submitTime)).format("L LT"),
            action: elem.additionalInfo.action,
            packs: []
        };
        elem.packs && elem.packs.length && elem.packs.map(function (el) {
            var _a;
            (_a = requestData.packs) === null || _a === void 0 ? void 0 : _a.push({
                serialNumber: el.serialNumber,
                productCode: el.productCode,
                batchId: el.batchId,
                expiryDate: el.expiryDate
            });
        });
        return requestData;
    }
};
var DeferredQueue = /** @class */ (function (_super) {
    __extends(DeferredQueue, _super);
    function DeferredQueue(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchResults = function () {
            var body = JSON.stringify(_this.state.request);
            Services_1.postJson(Endpoints_1.default.GetDeferredQueue, body, undefined, true, new Services_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: _this.props.applicationData.selectedLocation }))).then(function (results) {
                var data = [];
                var nonExpandable = [];
                var tokens = _this.state.tokens;
                if (results !== true) {
                    var j = JSON.parse(results);
                    var reportRows = Services_1.ReportsRequestService.parseServerData(j.records);
                    reportRows.map(function (row) {
                        nonExpandable.push(row.id);
                        data.push(getReport(row, row.id, _this.props.applicationData.resources, function () { _this.handledExpand(row.id); }));
                    });
                    if (j.token) {
                        tokens.push(j.token);
                    }
                }
                _this.setState(function (prevState) { return ({
                    data: data,
                    pending: false,
                    tokens: tokens,
                    nonExpandable: nonExpandable
                }); });
            })
                .catch(function (err) { return console.error(err); });
        };
        _this.handledExpand = function (id) {
            _this.setState({
                expanded: _this.state.expanded.includes(id) ? _this.state.expanded.filter(function (x) { return x !== id; }) : __spreadArrays(_this.state.expanded, [id])
            });
        };
        _this.onTableChange = function (type, newState) {
            _this.setState({ tableState: newState });
            _this.setState({ pending: true, data: [] });
            var tokens = _this.state.tokens;
            if (_this.state.tableState.page > newState.page) {
                tokens.pop();
                if (tokens.length == newState.page) {
                    tokens.pop();
                }
            }
            var token = tokens.length > 0 ? tokens[tokens.length - 1] : null;
            _this.setState(function (prevState) { return ({
                tableState: newState,
                pending: true,
                tokens: tokens
            }); }, _this.fetchResults);
        };
        _this.state = {
            data: [],
            pending: true,
            totalSize: 10,
            tableState: {
                sizePerPage: 10,
                page: 1
            },
            expanded: [],
            nonExpandable: [],
            tokens: [],
            request: {
                token: null,
                page: 1,
                itemsCount: 10
            }
        };
        _this.tableRef = React.createRef();
        return _this;
    }
    DeferredQueue.prototype.componentDidMount = function () {
        this.fetchResults();
    };
    DeferredQueue.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.applicationData.deferredQueueCount !== this.props.applicationData.deferredQueueCount) {
            this.fetchResults();
        }
    };
    DeferredQueue.prototype.render = function () {
        var _this = this;
        var expandRow = {
            renderer: function (row) {
                var _a;
                (_a = row.packs) === null || _a === void 0 ? void 0 : _a.map(function (pack) {
                    return (React.createElement("tr", { key: pack.serialNumber },
                        React.createElement("td", null, pack.serialNumber),
                        React.createElement("td", null, pack.productCode),
                        React.createElement("td", null, pack.batchId),
                        React.createElement("td", null, pack.expiryDate)));
                });
            }
        };
        return (React.createElement(Components_1.DashboardPage, { content: React.createElement(react_bootstrap_table2_toolkit_1.default, { keyField: "id", data: this.state.data, columns: Types_1.GetDeferredQueueTableColumns(this.props.applicationData.resources) }, function (props) { return (React.createElement("div", null,
                React.createElement(react_bootstrap_table_next_1.default, __assign({}, props.baseProps, { bootstrap4: true, condensed: true, hover: _this.state.data.length > 0, noDataIndication: function () { return _this.state.pending ? React.createElement(Components_2.CustomSpinner, null) : React.createElement("div", null, _this.props.applicationData.resources.NoData); }, remote: {
                        filter: false,
                        pagination: true,
                        sort: false,
                        cellEdit: false
                    }, ref: _this.tableRef, onTableChange: _this.onTableChange, bordered: false, keyField: "id", defaultSorted: Types_1.DeferredQueueTableDefaultSort, pagination: react_bootstrap_table2_paginator_1.default({ page: _this.state.tableState.page, totalSize: _this.state.totalSize, hideSizePerPage: true, paginationSize: 1, withFirstAndLast: false }), expandRow: expandRow })))); }), actions: React.createElement(Components_1.ActionButton, { key: "clear", action: { value: "clear", displayName: this.props.applicationData.resources.ClearQueue }, onClick: function () {
                    if (_this.state.data.length > 0) {
                        Services_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.ClearQueueEvent(function () { }, _this.props.applicationData.resources, _this.props.applicationData.selectedLocation));
                    }
                }, active: false, disabled: this.state.data.length <= 0 }), placeholder: "", title: this.props.applicationData.resources.DeferredRecordsQueued, resources: this.props.applicationData.resources }));
    };
    return DeferredQueue;
}(React.Component));
exports.DeferredQueue = DeferredQueue;
//# sourceMappingURL=DeferredQueue.js.map